export default function NavService() {
    return {
        mainNavItems: [
            {
                name: "Alle aktiviteter",
                path: "/activities",
                icon: "icon-activity",
                mobileDisplay: true,
            },
            {
                name: "Alle steder",
                path: "/locations",
                icon: "icon-sted",
                mobileDisplay: true,
            },
            {
                name: "Praktisk Info",
                path: "/practical",
                icon: "icon-info",
                mobileDisplay: true,
            },
            {
                name: "Faq",
                path: "/faq",
                icon: "icon-faq",
                mobileDisplay: true,
            },
            {
                name: "Priser",
                path: "/prices",
                icon: "icon-info",
                mobileDisplay: true,
            },
            {
                name: "Kontakt",
                path: "/contact",
                icon: "icon-kontakt",
                mobileDisplay: true,
            },
        ],
    };
}
